var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{attrs:{"height":_vm.carouselHeight,"indicator-position":"none","interval":5000}},_vm._l((_vm.urls),function(url){return _c('el-carousel-item',{key:url},[_c('el-image',{attrs:{"src":url,"fit":"fill"}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }